import type { NavigateOptions } from 'react-router-dom';

/**
 * `setSearchParams` options that do not throw away `location.state`.
 *
 * react-router's `setSearchParams(next, options)` is a thin wrapper around
 * `navigate("?" + next, options)`. `navigate` builds a brand new location, and
 * its state is whatever `options.state` says — so an options object that omits
 * `state` does not "leave it alone", it sets it to null.
 *
 * Every page that keeps a filter or a tab in the query string and *also* reads
 * something out of `location.state` therefore erases that state the first time
 * the reader touches a control. On the backtest dashboard the erased field was
 * `returnTo`, so the workflow editor lost the record of where it had been
 * opened from and its Back button fell through to browser history — which, one
 * entry back, is the dashboard the reader just came from.
 *
 * Query-string state and navigation state are independent; changing one must
 * not silently clear the other.
 */
export function keepingNavState(
    locationState: unknown,
    options: NavigateOptions = {}
): NavigateOptions {
    return { ...options, state: locationState ?? null };
}
